var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2154_10126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.35303 14.1163L0.73114 19.7384C0.259644 20.2099 0 20.8369 0 21.5035C0 22.1704 0.259644 22.7974 0.73114 23.2689C1.20264 23.7404 1.82959 24 2.49646 24C3.16315 24 3.7901 23.7404 4.2616 23.2689L9.88367 17.647C8.43732 16.778 7.22205 15.5627 6.35303 14.1163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1489 4.047C12.5001 4.047 10.345 6.20215 10.345 8.85095C10.345 11.4999 12.5001 13.6549 15.1489 13.6549C17.7979 13.6549 19.9529 11.4999 19.9529 8.85095C19.9529 6.20215 17.7977 4.047 15.1489 4.047ZM17.86 7.93066L15.0272 10.7635C14.8902 10.9006 14.7106 10.9691 14.5309 10.9691C14.3515 10.9691 14.1719 10.9006 14.0349 10.7637L12.4379 9.16663C12.1639 8.8927 12.1639 8.4483 12.4379 8.17438C12.712 7.90027 13.1562 7.90027 13.4303 8.17438L14.5309 9.27502L16.8676 6.93842C17.1417 6.66449 17.5859 6.66449 17.86 6.93842C18.1341 7.21234 18.1341 7.65674 17.86 7.93066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.149 0C10.2686 0 6.2981 3.97046 6.2981 8.85095C6.2981 13.7313 10.2687 17.7019 15.149 17.7019C20.0295 17.7019 24 13.7313 24 8.85095C24 3.97046 20.0295 0 15.149 0ZM15.149 15.0582C11.7264 15.0582 8.94177 12.2737 8.94177 8.85095C8.94177 5.42816 11.7264 2.64368 15.149 2.64368C18.5718 2.64368 21.3565 5.42816 21.3565 8.85095C21.3565 12.2737 18.5718 15.0582 15.149 15.0582Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2154_10126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.2560392de10bc02126de3f1eb66f624c.svg";
export { ForwardRef as ReactComponent };